import { Autocomplete, Box, Button, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from "../../../Components/Loader";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { DataGrid } from "@mui/x-data-grid";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

const TherapyCombinations = () => {
    const [formState, setFormState] = useState({
        category: null,
        treatment: null,
        duration: null,
        unit: "Minutes",
        no_of_therapists: null,
        patient_type: null,
    });

    const [treatments, setTreatments] = useState([]);
    const [mappingList, setMappingList] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [EditID, setEditID] = useState(null);

    const [message, setMessage] = useState({
        isErrorMsgText: "",
        successMsgText: "",
        isErrorMsg: false,
        successMsg: false,
    });
    const [isloader, setisloader] = useState(false);
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);

    const categoryList = ["Medications", "Equipments", "Materials"];
    const therapistCount = [1, 2, 3, 4, 5];
    const patientTypes = ["Regular", "Vulnerabilities"];
    const unitList = ["Minutes"]

    let commonDisable = CheckAccessFunc("ayurveda", "Settings", "Therapy Mapping", "Therapy Mapping Master", "SubTab")?.editAccess;

    useEffect(() => {
        getTreatments();
        getMappings();
    }, []);

    const getTreatments = () => {
        try {
            RestAPIService.getAll(Serviceurls.AYURVEDA_TREATMENT_MASTER)
                .then((response) => {
                    if (response.data.status === "success") {
                        setTreatments(response?.data?.data || []);
                    }
                })
                .catch((e) => errorMessage(e?.message));
        } catch (e) {
            errorMessage(e?.message);
        }
    };

    const getMappings = () => {
        try {
            setisloader(true);
            RestAPIService.getAll(Serviceurls.AYURVEDA_THERAPY_COMBINATIONS)
                .then((response) => {
                    if (response.data.status === "success") {
                        setMappingList(response?.data?.data || []);
                    }
                    setisloader(false);
                })
                .catch((e) => {
                    setisloader(false);
                    errorMessage(e?.message);
                });
        } catch (e) {
            setisloader(false);
            errorMessage(e?.message);
        }
    };

    const AddMapping = () => {
        try {
            // if (!formState.category) return errorMessage("Please select Category");
            if (!formState.treatment) return errorMessage("Please select Treatments");
            if (!formState.duration) return errorMessage("Please enter Duration");
            if (!formState.unit) return errorMessage("Please enter Unit");
            if (!formState.no_of_therapists) return errorMessage("Please select No. of Therapists");
            if (!formState.patient_type) return errorMessage("Please select Patient Type");

            let data = {
                // category: formState.category,
                treatment: formState.treatment.id,
                duration: Number(formState.duration),
                unit: formState.unit,
                no_of_therapists: formState.no_of_therapists,
                patient_type: formState.patient_type,
                is_active: isActive,
            };

            setisloader(true);
            let apiCall = EditID
                ? RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_THERAPY_COMBINATIONS)
                : RestAPIService.create(data, Serviceurls.AYURVEDA_THERAPY_COMBINATIONS);

            apiCall
                .then((response) => {
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        clearForm();
                        getMappings();
                    }
                    setisloader(false);
                })
                .catch((e) => {
                    setisloader(false);
                    errorMessage(e?.response?.data?.message || e?.message);
                });
        } catch (e) {
            setisloader(false);
            errorMessage(e?.message);
        }
    };

    const clearForm = () => {
        setFormState({
            category: null,
            treatment: null,
            duration: null,
            unit: "Minutes",
            no_of_therapists: null,
            patient_type: null,
        });
        setIsActive(true);
        setEditID(null);
    };

    const deleteMapping = () => {
        try {
            let ID = deletedID ? [deletedID] : (delIDs || []);
            RestAPIService.delete(Serviceurls.AYURVEDA_THERAPY_COMBINATIONS + `?ids=${ID}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        getMappings();
                        setdelIDs([]);
                        setCheckBoxList([]);
                        setdeletedID(null);
                        setisDelete(false);
                    }
                })
                .catch((e) => errorMessage(e?.message));
        } catch (e) {
            errorMessage(e?.message);
        }
    };

    const errorMessage = (msg) =>
        setMessage({ ...message, isErrorMsg: true, isErrorMsgText: msg });

    const successMessage = (msg) =>
        setMessage({ ...message, successMsg: true, successMsgText: msg });

    const msgClose = () =>
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: "",
            successMsg: false,
            successMsgText: "",
        });

    const tableView = () => {
        const grpDelete = () => setisDelete(true);
        const gridToolBar = () => (
            <Box>
                <CommonGridToolBarWithFilterText
                    isDelete={delIDs?.length > 0}
                    removeData={grpDelete}
                />
            </Box>
        );

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id);
            let selectedRows = mappingList?.filter((row) => selectedIDs.has(row.sno));
            let FinalData = selectedRows.map((item) => item.id);
            setdelIDs(FinalData);
        };

        mappingList?.forEach((element, index) => (element.sno = index + 1));

        const columns = [
            {
                field: "sno",
                headerName: "S.No",
                flex: 0.05,
                sortable: false,
                renderCell: (params) => (
                    <Typography fontSize={"0.9vw"}>
                        {params.row.sno}
                    </Typography>
                ),
            },
            // { field: "category", headerName: "Category", flex: 0.15 },
            {
                field: "treatment_name",
                headerName: "Treatment",
                flex: 0.3,
                renderCell: (params) => {
                    let name = (params.row.treatment_name || [])
                    return name.length > 30 ? (
                        <Tooltip
                        // title={name.join(", ")}
                        >
                            <Typography fontSize={"0.9vw"}>
                                {name.slice(0, 28) + "..."}
                            </Typography>
                        </Tooltip>
                    ) : (
                        <Typography fontSize={"0.9vw"}>{name}</Typography>
                    );
                },
            },
            { field: "duration", headerName: "Duration", flex: 0.1 },
            { field: "unit", headerName: "Unit", flex: 0.1 },
            { field: "no_of_therapists", headerName: "No. of Therapists", flex: 0.1 },
            { field: "patient_type", headerName: "Patient Type", flex: 0.15 },
            {
                field: "is_active",
                headerName: "Status",
                flex: 0.1,
                renderCell: (params) => (
                    <Box>{params.row.is_active ? "Active" : "Inactive"}</Box>
                ),
            },
            ...(commonDisable
                ? [
                    {
                        field: "action",
                        headerName: "Action",
                        flex: 0.15,
                        headerAlign: "center",
                        align: "center",
                        renderCell: (params) => (
                            <Stack direction="row" spacing={1}>
                                <CommonEditButton
                                    size="1.5vw"
                                    onClick={() => {
                                        setFormState({
                                            category: params.row.category,
                                            treatment: params.row.treatment,
                                            duration: params.row.duration,
                                            unit: params.row.unit,
                                            no_of_therapists:
                                                params.row.no_of_therapists,
                                            patient_type: params.row.patient_type,
                                        });
                                        setIsActive(params.row.is_active || false);
                                        setEditID(params.row.id);
                                    }}
                                />
                            </Stack>
                        ),
                    },
                ]
                : []),
        ];

        return (
            <Box sx={{ height: "64vh" }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={mappingList || []}
                    columns={columns}
                    getRowId={(row) => row["sno"]}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                }}
                            >
                                {"No Records To Be Shown"}
                            </Box>
                        ),
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setpage(model.page)
                        setpageSize(model.pageSize)
                    }}
                    headerHeight={40}
                    density="compact"
                    disableRowSelectionOnClick
                    loading={isloader}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                />
            </Box>
        );
    };

    return (
        <Box sx={{ height: "79.5vh", width: "94vw", backgroundColor: Colors.Background, padding: ".5vw" }}>
            {/* Form Section */}
            <Box sx={{ height: "15vh", width: "93vw", backgroundColor: "white", padding: "0.5vw" }}>
                <Box sx={{ display: "flex", flexDirection: "row", gap: "1vw", flexWrap: "wrap" }}>
                    {/* <Autocomplete
                    options={categoryList}
                    value={formState.category}
                    onChange={(e, val) => setFormState((p) => ({ ...p, category: val }))}
                    renderInput={(params) => <TextField {...params} label="Category *" size="small" />}
                    sx={{ width: "15vw" }}
                /> */}

                    <Autocomplete
                        size="small"
                        limitTags={1}
                        options={treatments}
                        value={treatments.find(treatment => treatment.id === formState.treatment) || formState.treatment}
                        getOptionLabel={(option) => {
                            if (typeof option === 'object' && option !== null) {
                                return option.treatment_name || "";
                            }
                            return option || "";
                        }}
                        onChange={(e, val) => setFormState((p) => ({ ...p, treatment: val }))}
                        renderInput={(params) => <TextField {...params} label="Treatment *" size="small" />}
                        sx={{ width: "25vw" }}
                    />

                    <TextField
                        size="small"
                        label="Duration *"
                        value={formState.duration ?? ""}
                        onChange={(e) => {
                            if (e.target.value <= 180) {
                                setFormState((p) => ({ ...p, duration: e.target.value }))
                            }
                        }
                        }
                        sx={{ width: "15vw" }}
                        InputLabelProps={{ shrink: true }}
                    />


                    <Autocomplete
                        options={unitList}
                        value={formState.unit}
                        onChange={(e, val) => setFormState((p) => ({ ...p, unit: val }))}
                        renderInput={(params) => <TextField {...params} label="Unit *" size="small" />}
                        sx={{ width: "10vw" }}
                    />

                    <Autocomplete
                        options={therapistCount}
                        value={formState.no_of_therapists}
                        onChange={(e, val) => setFormState((p) => ({ ...p, no_of_therapists: val }))}
                        renderInput={(params) => <TextField {...params} label="No. of Therapists *" size="small" />}
                        sx={{ width: "12vw" }}
                    />

                    <Autocomplete
                        options={patientTypes}
                        value={formState.patient_type}
                        onChange={(e, val) => setFormState((p) => ({ ...p, patient_type: val }))}
                        renderInput={(params) => <TextField {...params} label="Patient Type *" size="small" />}
                        sx={{ width: "15vw" }}
                    />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                    <FormControlLabel
                        control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} disabled={!EditID} size="small" />}
                        label="Active"
                    />
                    <Box>
                        <Button size="small" variant="outlined" sx={{ textTransform: "capitalize", mr: 1 }} disabled={!commonDisable} onClick={clearForm}>
                            Clear
                        </Button>
                        <Button size="small" variant="contained" sx={{ textTransform: "capitalize" }} disabled={!commonDisable} onClick={AddMapping}>
                            {EditID ? "Update" : "Save"}
                        </Button>
                    </Box>
                </Box>
            </Box>

            {/* Table Section */}
            <Box sx={{ height: "64vh", width: "93vw", mt: ".5vw", backgroundColor: "white" }}>
                {tableView()}
            </Box>

            {/* Toast + Loader + Delete */}
            {message.isErrorMsg && <ToastMsg severity="error" msg={message.isErrorMsgText} msgPop={msgClose} />}
            {message.successMsg && <ToastMsg severity="success" msg={message.successMsgText} msgPop={msgClose} />}
            {isDelete && (
                <DeletePopup
                    DeletTitle="This action will delete the mapping. Are you sure?"
                    DeleteNotify="This action cannot be undone."
                    deleteAlertPopupClose={() => {
                        setisDelete(false);
                        setdeletedID(null);
                    }}
                    removeData={deleteMapping}
                    ButtonText="Yes"
                />
            )}
            <Loader loaderOpen={isloader} />
        </Box>
    );


};

export default TherapyCombinations;